import { render, staticRenderFns } from "./OrderedSchedule.vue?vue&type=template&id=0fdf06e2&scoped=true"
import script from "./OrderedSchedule.vue?vue&type=script&lang=ts"
export * from "./OrderedSchedule.vue?vue&type=script&lang=ts"
import style0 from "./OrderedSchedule.vue?vue&type=style&index=0&id=0fdf06e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdf06e2",
  null
  
)

export default component.exports